import React from 'react';
// app/components/tour/TourModal.tsx


interface TourModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const TourModal: React.FC<TourModalProps> = ({ onConfirm, onCancel }) => {
  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50'>
      <div className='w-full max-w-md rounded-lg bg-white p-6'>
        <h2 className='mb-4 text-2xl font-bold'>Welcome to Our Product Tour</h2>
        <p className='mb-6'>
          Let us guide you through the key features of our application. This
          tour will take about 2 minutes and will show you how to get the most
          out of our platform.
        </p>
        <div className='flex justify-end space-x-3'>
          <button
            onClick={onCancel}
            className='rounded-md border border-gray-300 px-4 py-2 hover:bg-gray-50'
          >
            Skip Tour
          </button>
          <button
            onClick={onConfirm}
            className='rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700'
          >
            Start Tour
          </button>
        </div>
      </div>
    </div>
  );
};

export default TourModal;
